/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Suggestion_LaterInputs */

const en_us2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not now`)
};

const pt_br2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const es_419_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora no`)
};

const pt_pt2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agora não`)
};

const fr_fr2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plus tard`)
};

const de_de2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht jetzt`)
};

const it_it2_plan_suggestion_later = /** @type {(inputs: Plan_Suggestion_LaterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ora`)
};

/**
* | output |
* | --- |
* | "Not now" |
*
* @param {Plan_Suggestion_LaterInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_suggestion_later = /** @type {((inputs?: Plan_Suggestion_LaterInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Suggestion_LaterInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_suggestion_later(inputs)
	if (locale === "es-419") return es_419_plan_suggestion_later(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_suggestion_later(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_suggestion_later(inputs)
	if (locale === "de-DE") return de_de2_plan_suggestion_later(inputs)
	if (locale === "it-IT") return it_it2_plan_suggestion_later(inputs)
	return en_us2_plan_suggestion_later(inputs)
});
export { plan_suggestion_later as "plan.suggestion.later" }